import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, HostListener, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AppService, GRSSResponse, GRSSUserRoles, ValueIdPair } from 'src/app/_services/app.service';
import { AddScheduleComponent } from './add-schedule/add-schedule.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { DialogConfirmComponent } from 'src/app/dialog/dialog-confirm/dialog-confirm.component';
import { ComponentCanDeactivate } from 'src/app/_guard/pending-changes.guard';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

type JoditConfig = { [key: string]: any };

@Component({
  selector: 'app-manage-communications',
  templateUrl: './manage-communications.component.html',
  styleUrls: ['./manage-communications.component.css'],
  animations: [
    trigger('slider', [
      state('*', style({
        height: 0
      })),
      state('show', style({
        height: '*'
      })),
      transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
    ])
  ],
  standalone: false
})

export class ManageCommunicationsComponent implements OnInit, ComponentCanDeactivate {

  treeControl = new NestedTreeControl<RecipientsListNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<RecipientsListNode>();

  isSelected = false;
  schedules: ValueIdPair[];
  senderlist: ValueIdPair[];
  marketlist: ValueIdPair[];
  triggerlist: ValueIdPair[];
  attachmentlist: ValueIdPair[];

  selectedSchedule: Schedule;
  selectedScheduleTemp: Schedule;

  operatorRoleName: string = GRSSUserRoles.Operator;

  enabledSpreadsheets: boolean = true;

  // Custom Jodit config with menu customizations
  joditConfig: JoditConfig = {
    buttons: [
      'paragraph',
      '|',
      'bold',
      'italic',
      'underline',
      'subscript',
      'superscript',
      //'eraser',
      '|',
      'link',
      'ul',
      'ol',
      '|',
      'left',
      'center',
      'right',
      //'indent',
      //'outdent',
      '|',
      'brush',
      'fontsize',
      'font',
      '|',
      'table',
      '|',
      'undo',
      'redo',
    ],
    table: {
      defaultAttributes: {
        border: 1,
        cellpadding: 2,
        cellspacing: 2,
      },
      useCellOptions: true, // This is important!
    }
  };

  constructor(private translate: TranslateService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private dialog: MatDialog, private cdr: ChangeDetectorRef, public service: AppService) {
    this.service.SetTranslation('administration/manage-communications');
  }

  ngOnInit() {
    this.checkEnableSpreadsheets();
    this.GetSchedules();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away

    let hasChanges: boolean = false;

    if (JSON.stringify(this.selectedSchedule) !== JSON.stringify(this.selectedScheduleTemp)) {
      hasChanges = true;
    }

    return !hasChanges;
  }




  onContentChange(newContent: string) {
    console.log('Editor content has changed:', newContent);
    //this.editorContent = newContent;
  }







  /** Assign all the list items to variables */
  SetListItems() {
    this.http.get<ListsItems>(this.baseUrl + 'api/communications/getListsItems').subscribe(result => {
      this.dataSource.data = result.recipientlist;
      if (this.selectedSchedule.recipientsIds.length > 0) {
        this.dataSource.data.forEach(node => {
          if (node.children.length > 0) {
            node.children.forEach(innerNode => {
              if (this.selectedSchedule.recipientsIds.includes(innerNode.id)) {
                innerNode.checked = true;
                this.treeControl.expand(node);
              } else {
                innerNode.checked = false;
              }
            });
          }
        }
        );
      }

      this.triggerlist = result.triggerlist;
      this.marketlist = result.marketlist;
      this.attachmentlist = result.attachmentlist;
      this.senderlist = result.senderlist;
    }, error => {
      console.error(error);
    });
  }

  /**
   * Updated the selected schedule recipients ids
   * @param id Selected ID
   * @param checked Represents whether checkbox checked or not
   */
  OnClickRecipient(id: string, checked: boolean) {
    if (checked === true) {
      if (this.selectedSchedule.recipientsIds.length > 0) {
        if (!this.selectedSchedule.recipientsIds.includes(id)) {
          this.selectedSchedule.recipientsIds.push(id);
        }
      } else {
        this.selectedSchedule.recipientsIds.push(id);
      }
    } else {
      if (this.selectedSchedule.recipientsIds.length > 0) {
        if (this.selectedSchedule.recipientsIds.includes(id)) {
          const index = this.selectedSchedule.recipientsIds.indexOf(id, 0);
          this.selectedSchedule.recipientsIds.splice(index, 1);
        }
      }
    }
  }


  hasChild = (_: number, node: RecipientsListNode) => !!node.children && node.children.length > 0;


  checkEnableSpreadsheets() {
    this.http.get(this.baseUrl + 'api/common/getSetting/EnableSpreadsheets', { responseType: 'text' }).subscribe(result => {
      if (result) {
        this.enabledSpreadsheets = this.service.getBoolean(result);
      }
    }, error => {
      console.error(error);
    });
  }

  /** Gets all the schedules */
  GetSchedules() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/communications/getSchedules').subscribe(result => {
      this.schedules = result;
    }, error => {
      console.error(error);
    });
  }

  /** Gets all the schedules */
  GetSchedule(scheduleId: string) {
    this.http.get<Schedule>(this.baseUrl + 'api/communications/getSchedule/' + scheduleId).subscribe(result => {
      this.isSelected = true;
      this.selectedSchedule = result;
      this.selectedScheduleTemp = JSON.parse(JSON.stringify(result));
      this.onChangeTrigger();
    }, error => {
      console.error(error);
    });
  }

  /**
   * Sets the selected schedule
   * @param schedule Selected schedule
   */
  OnChangeSchedule(scheduleId: string) {
    this.SetListItems();
    this.GetSchedule(scheduleId);
  }

  /*** Fires when user clicks the create NEW schedule */
  OnCreateSchedule() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.position = { top: '5%' };
    this.dialog.open(AddScheduleComponent, dialogConfig).afterClosed().subscribe(res => {
      if (res === 1) {
        this.selectedSchedule = null;
        this.selectedScheduleTemp = null;
        this.isSelected = false;
        this.GetSchedules();
      }
    });
  }

  /** Delete button event */
  OnDeleteClick() {
    if (this.service.currentUser.userRole !== GRSSUserRoles.Operator) {
      this.dialog.open(DialogConfirmComponent, {
        disableClose: true,
        data: {
          title: this.translate.instant('Communications.Scheduler.Messages.msgHeaderDelete'),
          message: this.translate.instant('Communications.Scheduler.Messages.msgParaDelete')
        },
        position: { top: '5%' }
      }).afterClosed().subscribe(result => {
        if (result === true) {
          this.service.showSpinner();
          this.http.delete<GRSSResponse>(this.baseUrl + 'api/communications/deleteScheduler/' + this.selectedSchedule.scheduleId).subscribe(res => {
            if (res.statusCode === 4) {
              this.service.SaveStatus(true, 'Communications.Scheduler.Messages.msgHeaderDelete', res.statusMessage);
            } else {
              if (res.statusCode === 1) {
                this.isSelected = false;
                this.GetSchedules();
              }
              this.service.SaveStatus(false, 'Communications.Scheduler.Messages.msgHeaderDelete', res.statusMessage);
            }
          }).add(() => {
            this.service.hideSpinner();
          });
        }
      });
    }
  }

  /** Save button event */
  OnSaveClick() {
    if (this.selectedSchedule.scheduleId) {
      this.service.showSpinner();
      this.http.put<GRSSResponse>(this.baseUrl + 'api/communications/updateSchedule', this.selectedSchedule).subscribe(result => {
        if (result.statusCode === 1) {
          this.service.SaveStatus(false, 'Communications.Scheduler.Messages.msgHeaderUpdate', result.statusMessage);
          this.GetSchedules();
          this.OnChangeSchedule(this.selectedSchedule.scheduleId);
        } else if (result.statusCode === 4) {
          this.service.SaveStatus(true, 'Communications.Scheduler.Messages.msgHeaderUpdate', result.statusMessage);
        } else {
          this.service.SaveStatus(false, 'Communications.Scheduler.Messages.msgHeaderUpdate', result.statusMessage);
        }

      }, error => {
        console.error(error);
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

  onChangeTrigger() {
    if (this.selectedSchedule.triggerId) {
      this.http.get<ValueIdPair[]>(this.baseUrl + 'api/communications/getAttachments/' + this.selectedSchedule.triggerId).subscribe(result => {
        this.attachmentlist = result;
      }, error => {
        console.error(error);
      });
    }
  }
}

/** An interace to access schedule details */
interface Schedule {
  scheduleId: string;
  name: string;
  senderId: string;
  subject: string;
  content: string;
  triggerId: string;
  recipientsIds: string[];
  marketIds: string[];
  attachmentIds: string[];
}

/** An interace to access list items used in the page */
interface ListsItems {
  recipientlist: RecipientsListNode[];
  marketlist: ValueIdPair[];
  triggerlist: ValueIdPair[];
  attachmentlist: ValueIdPair[];
  senderlist: ValueIdPair[];
}

/** An interace to access Node list */
interface RecipientsListNode {
  name: string;
  // maticon: string;
  id?: string;
  checked?: boolean;
  children?: RecipientsListNode[];
}
